import React, { useEffect, useState } from "react";
import styles from "./AtendimentoWhatsapp.module.css";

// Mesmos valores padrão de backend/services/whatsapp/atendimentoConfig.service.js
// — o que o estabelecimento nunca salvou aparece aqui já no padrão.
const PADRAO = {
  msg_boas_vindas: "",
  msg_encerramento: "",
  msg_fechado: "",
  aceita_cartao: true,
  aceita_dinheiro: true,
  perguntar_troco: true,
  aceita_entrega: true,
  aceita_retirada: true,
  pedido_minimo_entrega: "",
  tempo_entrega: "",
  tempo_retirada: "",
  perguntar_observacao: true,
  atendente_habilitado: true,
  atendente_inicio: "",
  atendente_fim: "",
  notificacoes: { em_preparo: true, pronto: true, saiu_entrega: true, entregue: false, cancelado: true },
  cardapio_formato: "pdf",
  sugestao_categoria_id: "",
  sugestao_texto: "",
  recompra_rapida: true
};

const AVISOS = [
  ["em_preparo", "Pedido em preparo"],
  ["pronto", "Pedido pronto (retirada / saindo pra entrega)"],
  ["saiu_entrega", "Saiu pra entrega (quando o entregador aceita)"],
  ["entregue", "Pedido entregue"],
  ["cancelado", "Pedido cancelado"]
];

function configInicial(salvo) {
  const s = salvo && typeof salvo === "object" ? salvo : {};
  return {
    ...PADRAO,
    ...s,
    pedido_minimo_entrega: s.pedido_minimo_entrega ?? "",
    sugestao_categoria_id: s.sugestao_categoria_id ?? "",
    notificacoes: { ...PADRAO.notificacoes, ...(s.notificacoes || {}) }
  };
}

function AtendimentoWhatsapp({ estabelecimento, buttonClassName, cardClassName, titleClassName, descriptionClassName, onSalvo }) {
  const [config, setConfig] = useState(() => configInicial(estabelecimento.whatsapp_config));
  const [categorias, setCategorias] = useState([]);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    setConfig(configInicial(estabelecimento.whatsapp_config));
  }, [estabelecimento.whatsapp_config]);

  useEffect(() => {
    const API_URL = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("token");
    fetch(`${API_URL}/estabelecimentos/${estabelecimento.id_estabelecimento}/categorias`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => (r.ok ? r.json() : []))
      .then(setCategorias)
      .catch(() => setCategorias([]));
  }, [estabelecimento.id_estabelecimento]);

  const alterar = (campo, valor) => setConfig(atual => ({ ...atual, [campo]: valor }));
  const alterarAviso = (chave, valor) => setConfig(atual => ({ ...atual, notificacoes: { ...atual.notificacoes, [chave]: valor } }));

  const salvar = async () => {
    if (!config.aceita_entrega && !config.aceita_retirada) {
      alert("Deixe pelo menos entrega ou retirada ativada.");
      return;
    }

    setSalvando(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/estabelecimentos/${estabelecimento.id_estabelecimento}/whatsapp/config`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(config)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Erro ao salvar");
      alert("Atendimento do WhatsApp salvo!");
      if (onSalvo) await onSalvo();
    } catch (error) {
      console.error("Erro ao salvar atendimento do WhatsApp:", error);
      alert(error.message || "Erro ao salvar o atendimento do WhatsApp.");
    } finally {
      setSalvando(false);
    }
  };

  const opcao = (campo, rotulo) => (
    <label className={styles.opcao}>
      <input type="checkbox" checked={Boolean(config[campo])} onChange={e => alterar(campo, e.target.checked)} />
      {rotulo}
    </label>
  );

  return (
    <div className={cardClassName}>
      <h3 className={titleClassName}>
         Atendimento do WhatsApp
      </h3>
      <p className={descriptionClassName}>
        Personalize como o atendimento automático conversa com seus clientes.
      </p>

      <div className={styles.secoes}>
        <div className={styles.secao}>
          <h4 className={styles.secaoTitulo}>Mensagens</h4>
          <p className={styles.ajuda}>Deixe em branco pra usar o texto padrão. Você pode usar {"{nome}"} e {"{restaurante}"}.</p>
          <label className={styles.campo}>
            Boas-vindas
            <textarea maxLength={500} value={config.msg_boas_vindas} placeholder="Olá, {nome}! 👋 Bem-vindo(a) ao {restaurante}." onChange={e => alterar("msg_boas_vindas", e.target.value)} />
          </label>
          <label className={styles.campo}>
            Encerramento (depois de confirmar o pedido)
            <textarea maxLength={500} value={config.msg_encerramento} placeholder="Obrigado, {nome}! Vamos te avisar por aqui sobre o andamento do pedido." onChange={e => alterar("msg_encerramento", e.target.value)} />
          </label>
          <label className={styles.campo}>
            Loja fechada (enviada fora do horário do card "Funcionamento" — o bot não aceita pedidos nesse período)
            <textarea maxLength={500} value={config.msg_fechado} placeholder="No momento estamos fechados 😴 Nosso horário é das {abertura} às {fechamento}." onChange={e => alterar("msg_fechado", e.target.value)} />
          </label>
        </div>

        <div className={styles.secao}>
          <h4 className={styles.secaoTitulo}>Pagamento</h4>
          <p className={styles.ajuda}>O Pix é configurado no card do WhatsApp abaixo.</p>
          {opcao("aceita_cartao", "Aceitar cartão (maquininha na entrega/retirada)")}
          {opcao("aceita_dinheiro", "Aceitar dinheiro")}
          {config.aceita_dinheiro && opcao("perguntar_troco", "Perguntar se precisa de troco")}
        </div>

        <div className={styles.secao}>
          <h4 className={styles.secaoTitulo}>Entrega e retirada</h4>
          {opcao("aceita_entrega", "Fazer entrega")}
          {opcao("aceita_retirada", "Permitir retirada no local")}
          <div className={styles.grade}>
            {config.aceita_entrega && (
              <label className={styles.campo}>
                Pedido mínimo pra entrega (R$)
                <input type="number" min="0" step="0.01" value={config.pedido_minimo_entrega} placeholder="Sem mínimo" onChange={e => alterar("pedido_minimo_entrega", e.target.value)} />
              </label>
            )}
            {config.aceita_entrega && (
              <label className={styles.campo}>
                Tempo estimado de entrega
                <input type="text" maxLength={40} value={config.tempo_entrega} placeholder="Ex: 40–60 min" onChange={e => alterar("tempo_entrega", e.target.value)} />
              </label>
            )}
            {config.aceita_retirada && (
              <label className={styles.campo}>
                Tempo estimado de retirada
                <input type="text" maxLength={40} value={config.tempo_retirada} placeholder="Ex: 20 min" onChange={e => alterar("tempo_retirada", e.target.value)} />
              </label>
            )}
          </div>
        </div>

        <div className={styles.secao}>
          <h4 className={styles.secaoTitulo}>Pedido</h4>
          <label className={styles.campo}>
            Como mostrar o cardápio
            <select value={config.cardapio_formato} onChange={e => alterar("cardapio_formato", e.target.value)}>
              <option value="pdf">PDF do cardápio</option>
              <option value="lista">Lista dentro do WhatsApp (o cliente toca no item)</option>
            </select>
          </label>
          {opcao("perguntar_observacao", 'Perguntar observação em cada item (ex: "sem cebola")')}
          {opcao("recompra_rapida", 'Oferecer "repetir último pedido" pra quem já comprou')}
          <div className={styles.grade}>
            <label className={styles.campo}>
              Sugerir complemento da categoria
              <select value={config.sugestao_categoria_id} onChange={e => alterar("sugestao_categoria_id", e.target.value === "" ? "" : Number(e.target.value))}>
                <option value="">Não sugerir</option>
                {categorias.map(c => (
                  <option key={c.id_categoria} value={c.id_categoria}>{c.nome_categoria}</option>
                ))}
              </select>
            </label>
            {config.sugestao_categoria_id !== "" && (
              <label className={styles.campo}>
                Texto da sugestão
                <input type="text" maxLength={120} value={config.sugestao_texto} placeholder="Que tal completar seu pedido? 😋" onChange={e => alterar("sugestao_texto", e.target.value)} />
              </label>
            )}
          </div>
        </div>

        <div className={styles.secao}>
          <h4 className={styles.secaoTitulo}>Atendimento humano</h4>
          {opcao("atendente_habilitado", 'Permitir que o cliente chame um atendente (digitando "atendente")')}
          {config.atendente_habilitado && (
            <div className={styles.grade}>
              <label className={styles.campo}>
                Atendentes disponíveis a partir de
                <input type="time" value={config.atendente_inicio} onChange={e => alterar("atendente_inicio", e.target.value)} />
              </label>
              <label className={styles.campo}>
                Até
                <input type="time" value={config.atendente_fim} onChange={e => alterar("atendente_fim", e.target.value)} />
              </label>
            </div>
          )}
          {config.atendente_habilitado && <p className={styles.ajuda}>Deixe os horários em branco se sempre tiver alguém pra responder.</p>}
        </div>

        <div className={styles.secao}>
          <h4 className={styles.secaoTitulo}>Avisos de status pro cliente</h4>
          <p className={styles.ajuda}>Mensagens automáticas enviadas quando a equipe muda o status de um pedido feito pelo WhatsApp.</p>
          {AVISOS.map(([chave, rotulo]) => (
            <label key={chave} className={styles.opcao}>
              <input type="checkbox" checked={Boolean(config.notificacoes[chave])} onChange={e => alterarAviso(chave, e.target.checked)} />
              {rotulo}
            </label>
          ))}
        </div>

        <div className={styles.rodape}>
          <button type="button" className={buttonClassName} onClick={salvar} disabled={salvando}>
            {salvando ? "Salvando..." : "Salvar atendimento"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AtendimentoWhatsapp;
